import Component from 'vue-class-component'
import Router from 'vue-router'
import Vue from 'vue'
import config from './config'
// Register the router hooks with their names
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate',
  'beforeRouteLeave',
])
Vue.use(Router)
// webpackChunkName 必须配置，且不重复
export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  base: config.app_name,
  routes: [
    {
      path: '/',
      component: () => import('./pages/index.vue'),
      name: '商品详情',
    },
    {
      path: '/shop',
      component: () => import('./pages/shop/index.vue'),
      name: '商城',
    },
    {
      path: '/book-detail',
      component: () => import('./pages/shop/picture-book.vue'),
      name: '绘本详情页',
    },
    {
      path: '/goodsSalesDetail',
      component: () => import('./pages/goods-new/collocation/detail.vue'),
      name: '搭配购',
    },
    {
      path: '/collocationList',
      component: () => import('./pages/goods-new/collocation/list.vue'),
      name: '搭配购列表',
    },
    {
      path: '/goodsView',
      component: () => import('./pages/goods-new/index.vue'),
      name: '商品详情',
    },
    {
      path: '/ketgoodsView',
      component: () => import('./pages/goods-new/ketIndex.vue'),
      name: 'ket商品详情',
    },
    {
      path: '/orderConfirm',
      component: () => import('./pages/order/orderConfirm.vue'),
      name: '确认订单',
    },
    {
      path: '/orderPay',
      component: () => import('./pages/order/orderPay.vue'),
      name: '订单支付',
    },
    {
      path: '/aliPayResult',
      component: () => import('./pages/order/aliPayResult.vue'),
      name: '支付结果',
    },
    {
      path: '/orderSnapshot',
      component: () => import('./pages/order/snapshot/orderSnapshot.vue'),
      name: '交易快照',
    },
    {
      path: '/orderSnapshotnew',
      component: () => import('./pages/order/snapshot-new/index.vue'),
      name: '交易快照',
    },
    {
      path: '/snapshotList',
      component: () => import('./pages/order/snapshot-new/snapshotList.vue'),
      name: '交易快照列表',
    },
    {
      path: '/payDone',
      name: '支付完成',
      component: () => import('./pages/order/payDone.vue'),
      beforeEnter: (to, from, next) => {
        console.log('beforeEnter')
        if (to.query.result && to.query.result.includes('cancel')) {
          let {
            spuId,
            type,
            channel_id = '',
            isCart = '',
            toList = '',
          } = to.query
          if (isCart) {
            next({ path: `/cart` })
          } else if (toList) {
            window.location.href = `${window.location.origin}/center/order/orderlist`
          } else {
            next({ path: `/goodsView`, query: { spuId, type, channel_id } })
          }
        } else {
          next()
        }
      },
    },
    {
      path: '/orderDetail',
      component: () => import('./pages/order/orderDetail.vue'),
      name: '订单详情',
    },
    {
      path: '/orderLogistics',
      component: () => import('./pages/order/orderLogistics.vue'),
      name: '物流详情',
    },
    {
      path: '/orderTracking',
      component: () => import('./pages/order/orderTracking.vue'),
      name: '物流跟踪',
    },
    {
      path: '/logisticsInfo',
      component: () => import('./pages/order/logisticsInfo.vue'),
      name: '物流信息',
    },
    {
      path: '/logisticsList',
      component: () => import('./pages/order/logisticsList.vue'),
      name: '物流列表',
    },
    {
      path: '*',
      component: () => import('./pages/comps/error.vue'),
    },
    // {
    //   path: '/presellRule',
    //   component: () => import(`./pages/comps/presellRule.vue`),
    // },
    // {
    //   path: '/groupList',
    //   component: () => import(`./pages/goods/groupList.vue`),
    // },
    {
      path: '/picPage',
      component: () => import('./commons/picPage.vue'),
      name: '图片',
    },
    {
      path: '/groupView',
      component: () => import('./pages/goods/groupView.vue'),
      name: '团购详情',
    },
    // {
    //   path: '/goodsView2',
    //   component: () => import('./pages/goods/goodsView2.vue'),
    //   name: 'crm报名商品详情',
    // },
    {
      path: '/signature',
      component: () => import('./pages/signature/signPage.vue'),
      name: 'signature',
    },
    {
      path: '/test/exchange',
      component: () => import('./pages/comps/exchangeCode.vue'),
      name: 'exchange',
    },
    {
      path: '/test/exchange2',
      component: () => import('./pages/comps/exCodePopup.vue'),
      name: 'exchange',
    },
    {
      path: '/cart',
      component: () => import('./pages/cart/index.vue'),
      name: '购物车',
    },
    {
      path: '/distribution',
      component: () => import('./pages/distribution/index.vue'),
      name: '分销活动页',
    },
    {
      path: '/wecome',
      component: () => import('./pages/wecome/index.vue'),
      name: '分层加企业微信',
    },
    {
      path: '/vipqrcode',
      component: () => import('./pages/vipqrcode/index.vue'),
      name: '会员分层加企业微信',
    },
    {
      path: '/orderclaim',
      component: () => import('./pages/orderclaim/index.vue'),
      name: '订单认领',
    },
    {
      path: '/claimrecord',
      component: () => import('./pages/orderclaim/claimrecord.vue'),
      name: '认领记录',
    },
    {
      path: '/claimdetail',
      component: () => import('./pages/orderclaim/claimdetail.vue'),
      name: '认领成功',
    },
    {
      path: '/conversion-coin',
      component: () => import('./pages/conversion-coin/index.vue'),
      name: '订单转金币',
    },
    {
      path: '/conversion-record',
      component: () => import('./pages/conversion-coin/record.vue'),
      name: '转换记录',
    },
    {
      path: '/purchaseRecord',
      component: () => import('./pages/purchase-record/index.vue'),
      name: '订单转换记录',
    },
    {
      path: '/ket-line',
      component: () => import('./pages/ket-line/index.vue'),
      name: 'key路线图',
    },
    {
      path: '/ket-test',
      component: () => import('./pages/ket-line/test.vue'),
      name: 'key测试',
    },
    {
      path: '/9thactivity',
      component: () => import('./pages/9thactivity/index.vue'),
      name: '9周年',
    },
  ],
})
